import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

// 職業狀況
export interface OccupationRow {
    enum_type: string;
    enum_id: string;
    enum_nm: string;
    enum_desc: string;
    enum_memo: string;
}

// 行業類別
export interface JobRow {
    jobid: string;
    jobdesc: string;
}

// 擔任職務 index
export interface JobTitleParentRow {
    enum_type: string;
    enum_id: string;
    enum_nm: string;
    enum_desc: string;
}
// 擔任職務 sub index
export interface JobTitleRow {
    enum_type: string;
    enum_id: string;
    enum_nm: string;
    enum_desc: string;
    enum_memo: string;
}

/**
 * @todo Api 回傳值
 */
export interface GetSubJobTitleCodeListResp extends GeneralResp {
    data: Array<JobTitleRow>;
}

/**
 * @todo 職務工作 細項
 * @param code
 */
const GetSubJobTitleCodeList = (code: string): Promise<Array<JobTitleRow>> => {
    const url = RouteUrlList.API_GetSubJobTitle.path;
    const data = { code: code };
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, data, config).then((res: AxiosResponse<GetSubJobTitleCodeListResp>) => {
        return res.data.data;
    });
};

export default GetSubJobTitleCodeList;
